module.exports = __webpack_public_path__ + "tasks.2dc84a49.webp";